<template>
    <div :tabindex="tabindex" @click="openStoriesModal(storyID)" @keypress="openStoriesModal(storyID)" class="cardWrapper">
      <div class="cardInner">
        <div class="candidateImage"
             :class="{
             Ailsa: storyID === 'Ailsa',
             Hamze: storyID === 'Hamze',
             David: storyID === 'David',
             Leonie: storyID === 'Leonie',
             Francesca: storyID === 'Francesca',
             Roy: storyID === 'Roy',
             Sengova: storyID === 'Sengova',
             Tony: storyID === 'Tony',}" >
        </div>
        <h3 class="name">{{ storyName }}</h3>
        <h3 class="position">{{ storyPosition }}</h3>
      </div>
    </div>
</template>

<script>
export default {
  name: 'RareStoriesStoryCard',
  props: {
    storyName: {
      type: String,
      required: true,
    },
    storyPosition: {
      type: String,
      required: true,
      default: '',
    },
    storyID: {
      type: String,
      required: true,
      default: '',
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    openStoriesModal(storyID) {
      this.$emit('openStoriesModal', storyID);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .cardWrapper {
    cursor: pointer;
    margin: 0 auto 44px auto;
    max-width: 276px;
    width: 100%;
  }

  .cardInner {
    width: 100%;
    padding: 0;
  }

  .candidateImage {
    width: 100%;
    max-width: 276px;
    background-position: top left;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 0;
  }

  .candidateImage:before{
    content: "";
    display: block;
    padding-top: 100%;/* initial ratio of 1:1*/
  }


  .name {
    color: $main-text;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    margin: 14px 0 0 0;
  }

  .position {
    color: #4a5b68;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.52;
    margin-top: -2px;
  }

  @media only screen and (max-width: 640px)  {

  }

  @media only screen and (min-width: 641px)  {


  }

  .Ailsa {
    background-image: url("../../../assets/img/photos/stories/Ailsa.jpg");
  }

  .Hamze {
    background-image: url("../../../assets/img/photos/stories/Hamze.png");
  }
  .David {
    background-image: url("../../../assets/img/photos/stories/David.jpg");
  }
  .Leonie {
    background-image: url("../../../assets/img/photos/stories/Leonie.jpg");
  }
  .Francesca {
    background-image: url("../../../assets/img/photos/stories/Nasteho.jpg");
  }
  .Tony {
    background-image: url("../../../assets/img/photos/stories/Tony.jpg");
  }
  .Roy {
    background-image: url("../../../assets/img/photos/stories/Roy.jpg");
  }
  .Sengova {
    background-image: url("../../../assets/img/photos/stories/Sengova.jpg");
  }


</style>



// WEBPACK FOOTER //
// src/pages/stories/components/RareStoriesStoryCard.vue